import { useQuery } from "react-query";
import { fetchPatientDetails } from "@/services/patient";
/** Milliseconds the EMR detail record stays fresh so all consumers share one fetch. */
var PATIENT_DETAILS_STALE_TIME = 5 * 60 * 1000;

/** Options controlling how a consumer reads the shared EMR detail record. */

/**
 * Query hook for a patient's EMR detail record. The primary consumer (left
 * sidebar) fetches once; secondary consumers pass `enabled: false` to reuse the
 * cached record without firing a duplicate request.
 */
export function usePatientDetails(workspaceId, patientId, options) {
  var _options$enabled;
  var idsReady = Boolean(workspaceId && patientId);
  return useQuery(["patient-details", workspaceId, patientId], function () {
    return fetchPatientDetails(workspaceId, patientId);
  }, {
    enabled: idsReady && ((_options$enabled = options === null || options === void 0 ? void 0 : options.enabled) !== null && _options$enabled !== void 0 ? _options$enabled : true),
    staleTime: PATIENT_DETAILS_STALE_TIME,
    retryOnMount: false,
    notifyOnChangeProps: "tracked"
  });
}